module.exports = __webpack_public_path__ + "img/customer_inactive.0d762a93.svg";